import axios from "axios";

// 后端服务地址（从环境变量读取）
const base = process.env.VUE_APP_BASE_API || 'http://localhost:8086';
console.log('base', base);

// GET 请求
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params,
    })
}

// POST 请求（JSON body）
export const postRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
    })
}
